<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	let props: HTMLAttributes<SVGSVGElement> = $props();
</script>

<svg viewBox="0 0 71 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
	<path
		d="M70.447.41h-6.738v47.57h6.738V.41ZM58.095.41h-6.738v47.57h6.738V.41ZM45.744 14.71h-6.738v33.271h6.738v-33.27ZM42.316 7.753l-2.08-2.083 2.08-2.083L44.4 5.67l-2.084 2.083Zm0-7.753a5.67 5.67 0 1 0 0 11.34 5.67 5.67 0 0 0 0-11.34ZM13.35 47.984h6.709V23.972a3.33 3.33 0 0 1 6.659 0v24.012h6.691V23.992a10.021 10.021 0 0 0-16.696-7.473A10.018 10.018 0 0 0 0 23.992V48h6.692V23.992a3.33 3.33 0 1 1 6.659 0v23.992Z"
		fill="currentColor"
	/>
</svg>
